import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type JivoWidgetsResponse as SchemaJivoWidgetsResponse } from '../schemas/JivoWidgetsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetJivoWidgetsContentType = '' as const;
export type GetJivoWidgetsRequest = void;
export type GetJivoWidgetsResponses = LinkCommonErrorResponses & {
    /**
     * @description Jivo widgets retrieved successfully
     */
    '200': {
        'application/json': SchemaJivoWidgetsResponse;
    };
    /**
     * @description Unauthorized
     */
    '401': {
        'application/json': SchemaError;
    };
};
export type GetJivoWidgetsResponseSuccess = GetJivoWidgetsResponses['200']['application/json'];
export type GetJivoWidgetsSearchParams = {
    authorization_code: string;
    state_token: string;
};
export type GetJivoWidgetsPathParameters = undefined;
export const GetJivoWidgetsUrl = '/integrations/jivo/widgets' as const;
export const GetJivoWidgetsMethod = 'GET' as const;
export const getGetJivoWidgetsUrl = (_params?: GetJivoWidgetsPathParameters) => GetJivoWidgetsUrl;
